import { AppLayout } from "../shared";
import MasterOrg from "../MasterOrg/MasterOrg";

const MasterOrg_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <MasterOrg props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default MasterOrg_layout;
